import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../../../providers";
import { AdmPanelContainerControllerImpl } from "../../../business/api";
import "./assets/css/adm-container.css";
import { Container, Header, Sidebar } from "./components";

export const AdmPanelContainer = ({ children }) => {
  const { userData, setCallbackLogin, handleLogout } = useAuth();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [isAdsSubscriber, setAdsSubscriber] = useState<string>('hidden');
  const controller = new AdmPanelContainerControllerImpl();
  const fetchData = async () => {
    if (isLoading) {
      try {
        const response = await controller.onLoad();
        setAdsSubscriber(response.response.ads);
      } catch (error) {
        console.error("Erro na requisição:", error);
        if (error === "401") {
          setCallbackLogin(
            {
              goBack: true,
              origin: '/adm/dashboard',
            }
          );
          handleLogout();
          navigate('/auth');
        } else {
          setIsLoading(true);
        }
      }
    } else {
      if (userData.username === "" || (userData.subscriber !== 'true' && userData.subscriber !== 'manager')) {
        setCallbackLogin(
          {
            goBack: true,
            origin: '/adm/dashboard',
          }
        );
        navigate('/auth');
        return;
      }
    }
  }

  useEffect(() => {
    fetchData();
  }, [userData]);

  return (
    <Row className="bg-dark vh-100" style={{ overflowY: "hidden" }}>
      <Col>
        <Header name={userData.username} image={userData.image} />
        <Row className="row-area">
          <Sidebar isSmall={false} userType={userData.subscriber} adsStatus={isAdsSubscriber} />
          <Container children={children} referer={undefined} navigate={undefined} />
        </Row>
      </Col>
    </Row>
  );
};
